<!-- <z-select
  id="{{ id() }}"
  [options]="options()"
  [optionLabel]="optionLabel()"
  [optionValue]="optionValue()"
  [placeholder]="placeholder()"
  [label]="label()"
  [class]="class"
  [filter]="true"
  [filterBy]="'Name'"
  [(ngModel)]="model"
  (ngModelChange)="onModelChange($event)"
  [ngModelOptions]="{ standalone: true }"
/> -->
<!-- [inputSecondaryText]="selectedOption()?.data != undefined ? `Διεύθυνση Παράδοσης: ${selectedOption()?.data?.Addresses?.[0]?.StreetName ?? ''} Αρ. ${selectedOption()?.data?.Addresses?.[0]?.StreetNumber ?? ''} ${selectedOption()?.data?.Addresses?.[0]?.City?.Title ?? ''} Τ.Κ ${selectedOption()?.data?.Addresses?.[0]?.PostalCode ?? ''}` : ''" -->
@if (mode() == 'edit' || mode() == 'lockedit') {
    <z-table-vs-select
        [lazy]="true"
        [searchable]="searchable()"
        [options]="_options()"
        [showLabel]="true"
        [disabled]="disabled"
        [searchLabel]="'Αναζήτηση Πελάτη'"
        [dataTableSchema]="dataTableSchema()"
        [inputDisable]="inputDisable()"
        [totalRecords]="totalRecords()"
        [rowDataSelect]="selectedOption()"
        [showClearIcon]="showClearIcon()"
        [showNewIcon]="showNewCustomerIcon()"
        [showNewIconTitle]="'Δημιουργία Καρτέλας Πελάτη'"
        [showEditIcon]="showEditCustomerIcon()"
        [showEditIconTitle]="'Μεταβολή Καρτέλας Πελάτη'"
        [stateKey]="'customers-select'"
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="model"
        (ngModelChange)="onNgModelChange($event)"
        (searchTermChange)="searchTermChange($event)"
        (inputFocus)="onInputFocus()"
        (inputBlur)="onInputBlur()"
        (lazyLoad)="onLazyLoad($event)"
        (inputDblClick)="onInputDblClick()"
        (rowDataSelectChange)="onRowDataSelect($event)"
        (newIconButton)="onNewIconButton()"
        (editIconButton)="onEditIconButton($event)"
    >
        <ng-template #selectedItem let-selectedRow>
            <div class="">
                @if (
                    selectedRow?.LegalType == 'IND' ||
                    selectedRow?.LegalType == 'INDM'
                ) {
                    {{ selectedRow?.SureName }}
                    {{ selectedRow.FIrstNameRaw }}
                    @if (selectedRow?.LegalType == 'INDM') {
                        ({{ selectedRow.BrandName ?? '' }}

                        @if ((selectedRow?.TaxId ?? '') != '') {
                            Α.Φ.Μ: {{ selectedRow?.TaxId }}
                        }
                        )
                    }
                } @else {
                    {{ selectedRow?.BrandName ?? '' }} Α.Φ.Μ:
                    {{ selectedRow?.TaxId }}
                }

                @if (
                    selectedRow?.ContactDetails &&
                    selectedOptionContactPhone() != ''
                ) {
                    <i
                        class="pi pi-phone ml-2"
                        style="color: var(--primary-color)"
                    ></i>
                    {{ selectedRow | zContactPrimaryPhone }}
                }
            </div>
        </ng-template>

        <ng-template #tableRowHeader let-columns="columns">
            <th>Επωνυμία</th>
            <th>Όνομα</th>
            <th>Τηλέφωνο</th>
            <th>Διεύθυνση</th>
            <th>Νομική Μορφή</th>
            <th>Α.Φ.Μ</th>
            <th>Οχήματα</th>
        </ng-template>

        <ng-template
            #tableRow
            let-rowData
            let-columns="columns"
            let-index="index"
        >
            <td>
                @if (
                    rowData?.LegalType == 'IND' || rowData?.LegalType == 'INDΜ'
                ) {
                    {{ rowData?.SureName }}
                } @else {
                    {{ rowData?.BrandName }}
                }
            </td>
            <td>
                {{
                    rowData?.FIrstNameRaw ??
                        rowData?.FirstName?.Name ??
                        rowData?.FIrstNameRaw
                }}
            </td>
            <td>{{ rowData | zContactPrimaryPhone }}</td>
            <td>
                {{ rowData | zCustomerPrimaryContactAddress: true }}
            </td>
            <td>{{ rowData | zCustomerLegalType }}</td>
            <td>{{ rowData?.TaxId }}</td>
            <td>{{ rowData | zCustomerSubjects }}</td>
        </ng-template>
    </z-table-vs-select>
} @else {
    <span>{{ selectedOption()?.data?.Code }}</span>
}
<!-- 
<p-dialog
    [(visible)]="customerVisibleDialog"
    [maximizable]="true"
    [appendTo]="'body'"
    [modal]="true"
    [style]="{ width: '90vw' }"
>
    <ng-template #header>
        <div class="inline-flex items-center justify-center gap-2">
            
            <span class="font-bold whitespace-nowrap">Πελάτης</span>
        </div>
    </ng-template>
    @if (customerVisibleDialog) {
        <app-customer-form
      #customerFormComponent
      [fetchDataForEditById]="fetchDataForEditById()"
    ></app-customer-form>
    }
    <ng-template #footer>
        
    </ng-template>
</p-dialog> -->
